import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ButtonComponent } from '../../misc';
import { provideUiKitScope } from '../../providers';

@Component({
  selector: 'ui-unsaved-changes-modal',
  imports: [ButtonComponent, TranslocoDirective],
  templateUrl: './unsaved-changes-modal.component.html',
  styleUrl: './unsaved-changes-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [provideUiKitScope()],
})
export class UnsavedChangesModalComponent {
  private readonly activeModal = inject(NgbActiveModal);

  protected stay(): void {
    this.activeModal.close(false);
  }

  protected leave(): void {
    this.activeModal.close(true);
  }
}
